import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, patch, post, put } from './agent';

const conversations =
  (aiUrl) =>
  (id = '') => {
    const url = _([aiUrl, 'conversations', id]).compact().join('/');

    return {
      list: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
      get: () => get(url),
      create: (body) => post(url, body),
      post: (body) => post(`${url}/messages`, body),
      rename: (body) => patch(url, body),
      delete: () => del(url),
      messages: (messageId = '') => {
        const msgUrl = _([url, 'messages', messageId]).compact().join('/');
        return {
          updateFeedback: (body) => patch(msgUrl, body),
        };
      },
    };
  };

const assistantProfiles =
  (workspacesUrl) =>
  (id = '') => {
    const baseUrl = `${workspacesUrl}/assistant-profiles`;
    const url = id ? `${baseUrl}/${id}` : baseUrl;

    return {
      list: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
      get: () => get(url),
      add: (body) => post(baseUrl, body),
      update: (body) => patch(url, body),
      remove: () => del(url),
    };
  };

const ai = (workspacesUrl) => {
  const url = _([workspacesUrl, 'ai']).compact().join('/');

  return {
    conversations: (id) => conversations(url)(id),
    assistantProfiles: (id) => assistantProfiles(workspacesUrl)(id),
    suggestions: () => get(`${url}/suggestions`),
    get: (path) => get(`${url}/${path}`),
    put: (path, body) => put(`${url}/${path}`, body),
  };
};

export default ai;
